import "bootstrap/dist/css/bootstrap.min.css";
/*import styles from "./app.module.css";*/

import Footer from "../Components/Footer";
import { Outlet } from "react-router-dom";
import Header from "../Components/Header";


function App() {   
  return (
    <>       
      <Header />
      <Outlet />
      <Footer />      
    </>
  );
}

export default App;
